import { notify } from 'utils/reduxUtils';

export const types = {
  GROUP_MEMBER_CHANGE_USER_GROUP_ERROR:
    'userGroupManagement/changeUserGroupModal/GROUP_MEMBER_CHANGE_USER_GROUP_ERROR',
  GROUP_MEMBER_CHANGE_USER_GROUP_REQUEST:
    'userGroupManagement/changeUserGroupModal/GROUP_MEMBER_CHANGE_USER_GROUP_REQUEST',
  GROUP_MEMBER_CHANGE_USER_GROUP_SUCCESS:
    'userGroupManagement/changeUserGroupModal/GROUP_MEMBER_CHANGE_USER_GROUP_SUCCESS',
  SUPER_USER_CHANGE_USER_GROUP_MODAL_OPEN:
    'userGroupManagement/changeUserGroupModal/SUPER_USER_CHANGE_USER_GROUP_MODAL_OPEN',
  SUPER_USER_CHANGE_USER_GROUP_MODAL_CLOSE:
    'userGroupManagement/changeUserGroupModal/SUPER_USER_CHANGE_USER_GROUP_MODAL_CLOSE',
  SUPER_USER_CHANGE_USER_GROUP_ERROR:
    'userGroupManagement/changeUserGroupModal/SUPER_USER_CHANGE_USER_GROUP_ERROR',
  SUPER_USER_CHANGE_USER_GROUP_REQUEST:
    'userGroupManagement/changeUserGroupModal/SUPER_USER_CHANGE_USER_GROUP_REQUEST',
  SUPER_USER_CHANGE_USER_GROUP_SUCCESS:
    'userGroupManagement/changeUserGroupModal/SUPER_USER_CHANGE_USER_GROUP_SUCCESS',
};

export const groupMemberChangeUserGroup = {
  error: notify(
    (error) => ({
      type: types.GROUP_MEMBER_CHANGE_USER_GROUP_ERROR,
      payload: { error },
    }),
    'Failed to change organization',
  ),
  request: ({ groupMemberId, nextUrl }) => {
    return {
      type: types.GROUP_MEMBER_CHANGE_USER_GROUP_REQUEST,
      payload: { groupMemberId, nextUrl },
    };
  },
  success: () => ({
    type: types.GROUP_MEMBER_CHANGE_USER_GROUP_SUCCESS,
  }),
};

export const superUserChangeUserGroupModal = {
  open: () => ({
    type: types.SUPER_USER_CHANGE_USER_GROUP_MODAL_OPEN,
  }),
  close: () => ({
    type: types.SUPER_USER_CHANGE_USER_GROUP_MODAL_CLOSE,
  }),
};

export const superUserChangeUserGroup = {
  error: (error) => ({
    type: types.SUPER_USER_CHANGE_USER_GROUP_ERROR,
    payload: { error },
  }),
  request: ({ userGroupId, nextUrl }) => ({
    type: types.SUPER_USER_CHANGE_USER_GROUP_REQUEST,
    payload: { userGroupId, nextUrl },
  }),
  success: () => ({
    type: types.SUPER_USER_CHANGE_USER_GROUP_SUCCESS,
  }),
};
